import { render, staticRenderFns } from "./GameGroupSwitch.vue?vue&type=template&id=74f3955a&scoped=true"
import script from "./GameGroupSwitch.vue?vue&type=script&lang=js"
export * from "./GameGroupSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f3955a",
  null
  
)

export default component.exports